import { ReactElement } from "react";
import { FormattedText, Typography } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { setTrackingId } from "client/Misc/utils";
import { prepareHubItemTitle } from "./AnnouncementActivity";
import { KnowledgeItemNotificationDataViewModel } from "client/Api/Notifications/notifications";

export type KnowledgeItemActivityProps = {
	data: KnowledgeItemNotificationDataViewModel;
};

export const KnowledgeItemActivity = (props: KnowledgeItemActivityProps): ReactElement => {
	const { data } = props;

	const title: string = prepareHubItemTitle(data.title);

	return (
		<>
			<span {...setTrackingId("title")}>
				<FormattedText
					text={
						localize(
							data.isNew
								? "_NewItemTitle"
								: "_UpdatedItemTitle"
						)
					}
					thingsToReplace={[
						{
							what: "{{Title}}",
							filler: (
								<Typography
									weight="bold"
									trackingId="knowledge-item-title"
								>
									{title}
								</Typography>
							)
						}
					]}
				/>
			</span>.
		</>
	);
};

KnowledgeItemActivity.displayName = "KnowledgeItemActivity";